import EnterExit from '@components/animation/EnterExit';
import MenuContext from '@context/MenuContext';
import { ChevronRight } from '@mui/icons-material';
import Link from 'next/link';
import React, { useContext } from 'react';

import useStyles from './Header.style';

export const leftMenuItems = [
  {
    id: 'services',
    title: 'Services',
    href: '/home-staging',
    submenu: [
      {
        id: 'staging',
        title: 'Staging',
        href: '/home-staging',
      },
      {
        id: 'cleaning',
        title: 'Cleaning',
        href: '/cleaning',
      },
      {
        id: 'moving',
        title: 'Moving',
        href: '/moving',
      },
      {
        id: 'photos',
        title: 'Photography',
        href: '/photos',
      },
    ],
  },
  {
    id: 'customers',
    title: 'Customers',
    href: '/home-buyer',
    submenu: [
      {
        id: 'agents',
        title: 'Agents',
        href: '/agents',
      },
      {
        id: 'Homeowners',
        title: 'Homeowners',
        href: '/home-staging',
      },
      {
        id: 'Brokerages',
        title: 'Brokerages',
        href: '/brokerages',
      }
    ],
  },
  {
    id: 'Resources',
    title: 'Resources',
    href: '/about',
    submenu: [
      {
        id: 'about-us',
        title: 'About Us',
        href: '/about',
      },
      {
        id: 'referral-program',
        title: 'Referral Program',
        href: '/referrals',
      },
      {
        id: 'financing',
        title: 'Prep Now, Pay Later',
        href: '/affirm',
      },
    ],
  },
  {
    id: 'Listings',
    title: 'Listings',
    href: '/shop/homes',
  }
];

const HeaderEnterExit = () => {
  const menuContext = useContext<MenuContext>(MenuContext);
  const { classes, cx } = useStyles();

  return (
    <EnterExit
      visible={menuContext.showHeaderNavigation}
      style={{ zIndex: 40 }}
    >
      <div className={classes.headerLeft}>
        <button
          className={cx({
            'hamburger': true,
            'hamburger--3dx': true,
            'is-active': menuContext.open,
            [classes.headerMenuToggle]: true,
          })}
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            menuContext.setContext(prev => ({ ...prev, open: !menuContext.open }));
          }}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>

        <ul
          className={classes.headerMenu}
        >
          {
            leftMenuItems.map((item, index) => {
              const className = classes.headerMenuItem;

              return (
                <li
                  key={index}
                  className={className}
                >
                  <Link
                    href={item.href}
                    title={item.title}
                    data-test={item.id}
                    id={item.id}
                  >
                    {item.title}
                    {item.submenu && (   
                      <ChevronRight sx={{ transform: 'rotate(90deg)' }} />
                    )}
                  </Link>
                  {item.submenu && (
                    <ul className={classes.headerSubmenu}>
                      {item.submenu.map((subItem, subIndex) => (
                        <li key={subIndex}>
                          <Link href={subItem.href}>
                            {subItem.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            })
          }
        </ul>
      </div>
    </EnterExit>
  );
};

export default HeaderEnterExit;
